import { SelectDashboardUnstyled } from './unstyled'
import styled from 'styled-components'

export const SelectDashboard = styled(SelectDashboardUnstyled)`
  position: relative;
  width: 100%;

  .select-wrapper {
    position: relative;
    width: 100%;
    height: 50px;
    ${props => props.heightAuto && 'height: auto !important;'}

    .select-field {
      background: ${props => props.theme.colors.alabaster} !important;
      ${props =>
        props.bgTransparent && 'background-color: transparent !important;'}
      border: none !important;
      /*height: 50px !important;*/
      width: 100% !important;
      ${props => props.widthAuto && 'width: auto !important;'}

      div {
        max-height: 50px !important;
      }

      hr {
        display: none !important;
      }

      button[disabled] svg {
        display: none !important;
      }

      div:nth-child(2) {
        div:nth-child(2) {
          /*height: 50px !important;*/
          /*line-height: 50px !important;*/
          top: 0 !important;
          font-size: ${props =>
            props.theme.fontSizes.materialUI.selectField} !important;
          padding-left: 15px !important;
          padding-right: 35px !important;
          color: ${props =>
            props.disabled || (props.input || {}).disabled
              ? props.theme.colors.darkAthensGray
              : props.theme.colors.secondary} !important;
          font-weight: initial !important;
        }
      }
    }

    svg {
      position: absolute;
      width: 13px;
      height: 100%;
      right: 20px;
      z-index: ${props => props.theme.zIndexes.mainContentWrapper.first};
      transform: rotate(90deg);
      fill: ${props =>
        props.disabled || (props.input || {}).disabled
          ? props.theme.colors.darkAthensGray
          : props.theme.colors.secondary};
      pointer-events: none;
    }
  }

  label {
    display: block;
    padding: 0;
    font-size: ${props => props.theme.fontSizes.form.label};
    color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.robotoRegular};
    line-height: 24px;
    margin: 0 0 10px 0;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Form/SelectDashboard/index.js